import link from '../../link/default';

const primary = (params) => link.primary(params);

export default primary;
